export const addForwardslashToLinks = link => {
  if (link.charAt(link.length - 1) === "/") {
    return link
  } else {
    return link + "/"
  }
}

export function getLateNiteMerchants(carouselData) {
  const lateNightMerchants = []

  carouselData.forEach(el => {
    el.stores.forEach(store => {
      if (store.store_details) {
        if (store.store_details.opening_times) {
          let checkStore = store.store_details.opening_times
            ? store.store_details.opening_times
            : { mon: [{ open: "07:00:00", close: "21:00:00" }] }
          // console.log("checkStore",checkStore["mon"])
          if (checkStore["mon"].length) {
            let close = checkStore["mon"][0].close
            if (close === "23:59:00") {
              let data = {
                store: store,
                tags: store.store_tags.map(e => e.name).join(","),
              }
              lateNightMerchants.push(data)
            }
          }
        }
      }
    })
  })
  return lateNightMerchants
}

export const getGtmUserType = () => {
  let gtmUserType = "NewUser"

  if (
    typeof localStorage !== "undefined" &&
    localStorage.getItem("recentSearches")
  ) {
    gtmUserType = "ReturnNonPersonalizedUser"
  }

  return gtmUserType
}

export const fireGtmEvent = obj => {
  if (typeof window !== "undefined" && obj !== "undefined") {
    window.gtmDataLayer = window.gtmDataLayer || []

    if (
      obj["eventDetails.category"] !== "SEO-FOOD|herobannermobile" ||
      obj["eventDetails.action"] === "click"
    ) {
      if (obj["eventDetails.category"] === "SEO-FOOD|herobannermobile")
        obj["eventDetails.category"] = "SEO-FOOD|herobanner"

      window.gtmDataLayer.push(obj)
    }
  }
}

export const shuffleArray = array => {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    // And swap it with the current element.
    temporaryValue = array[currentIndex]
    array[currentIndex] = array[randomIndex]
    array[randomIndex] = temporaryValue
  }

  return array
}

export function hyphenDelimitedLowerCase(str) {
  return str.toLowerCase().split(" ").join("-")
}

export function titleCase(str) {
  var splitStr = str.toLowerCase().split(" ")
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
  }
  // Directly return the joined string
  return splitStr.join(" ")
}

export const getContentTemplateData = (location, countryUrl) => {
  let data = [
    {
      text: `Are you looking to order cheap food online in ${location}? Don’t fret. Now you can order food online any time with airasia Food or the airasia super app. What’s more, you can even order food for future deliveries. 

Visit airasia Food, one of the best online food delivery platforms in the market, and check out ‘food delivery near me’. With this food delivery service, you’ll find hundreds of food merchants offering various types of cuisine such as Asian, Vegetarian, Western and Healthy. There are also many choices of Beverages and Desserts. 
    
All you need to do is apply the filter for the type of cuisine you’re looking for and you’ll be shown a list of restaurants that are closest to you. If you cannot decide on what you want to have, simply look through all the categories until you find a meal that’s right for you. 
    
If you’re in the ${location}, you can search for vegetarian food delivery in ${location} or halal food delivery in ${location}. There’s even dessert delivery in ${location}, and you’ll surely find something on airasia food that will whet your appetite. 
    
To get more discounted prices on your online food delivery, download the airasia super app. Through this food delivery app, you’ll get promotions and affordable prices on food that you will not find anywhere else. 
    
With airasia Food, cheap online food delivery has become so easy and accessible.`,
      title: `Online Food Delivery in ${location}`,
    },
    {
      text: `Buying food online has become an integral part of our daily lives. You can now purchase almost every type of food online now at affordable and discounted prices from a wide range of merchants. 

When you want to order food online, just visit airasia Food and search for ‘food delivery near me’ and a whole list of restaurants and their offerings will be presented to you. So, whether you’re looking for hearty Asian delights or sumptuous Western fare, you’ll surely find it on airasia Food. 

Just search for the cuisine that you feel like having. For instance, vegetarian food delivery in ${location}, healthy food delivery in ${location} or halal food delivery in ${location}. 
                
There’s even dessert delivery in ${location} for those who like their sweets. It has never been easier to order food online in ${location} and in the ${location}.
                
Looking to order cheap food online? Then don’t forget to download the airasia super app. This is one of the best food delivery apps in the market and offers you plenty of cheap online food delivery options. There are loads of ongoing food promotions in ${location} where you can get the best food online delivery for really low prices. 
                
So, remember to keep an eye out for these awesome deals on both airasia Food and also on the airasia super app.`,
      title: `Food Promotions in ${location}`,
    },
    {
      text: `Muslims observe strict food restrictions and pay extra attention to what they eat. The ingredients, food handling and site of food preparation must meet strict guidelines for it to be permissible for Muslims to consume.  
      
You can now dine on delicious halal food in ${location} from Muslim friendly establishments with the halal food delivery service from airasia Food. This halal meal delivery service is our commitment to bringing great food from all over ${location} to our Muslim customers. You can now enjoy halal certified food without worries. 
      
Lip smacking dishes are available for you to enjoy when you order halal food online from airasia Food. Savour the top halal food in ${location} without even stepping out of the house. Your dining experience on delicious food just gets better and better with the quick delivery service, great discounts and the Big Points airasia Big Members earn with every purchase. 
      
Halal Chinese and pork free dishes are very popular on airasia food with many Chinese Muslim restaurants available on board airasia food. The dishes served are authentic and delicious. But if you are in the mood for Western dishes, go to the airasia Food page and look for Western halal food near me. The site/app will give you options on restaurants that serve halal Western food located close to you.
      
Halal Korean food delivery service is also available if you are looking for Korean dishes like bulgogi or bibimbap. Similarly, if you want to lead a healthier lifestyle, halal healthy food delivery service will help you reach your lifestyle goals.`,
      title: `Best Halal Food in ${location}`,
    },
    {
      text: `Asia is a melting pot of cultures and the food is certainly one of the best in the world. Now, you don’t need to visit far flung countries to taste the best food in Asia. Simply order from airasia Food and savour the top Asian food in ${location}!

Top Asian food shops have gone online with airasia Food. These restaurants, diners and street hawkers serve the most delicious Asian fare in ${location} and bring you their signature dishes. You can even try famous street food from night markets in ${location}!
    
The Asian food delivery service from airasia Food has handpicked restaurants that serve authentic Asian cuisines. These restaurants are well known for their top Asian dishes in ${location} and have carved a name for themselves. The good food they serve can now be enjoyed with your loved ones at your own dining table. 
    
Popular Asian food delivery includes dishes from the Chinese cuisine such as fried rice, noodle dishes, deep fried and steamed dishes and even dim sum. These all-time favourites from many renowned Chinese restaurants are now available from airasia food. Likewise, you can also enjoy mouthwatering meals from other Asian restaurants that serve food from Japan, Thailand, Sri Lanka, South Korea and Vietnam. These are just some of the celebrated cuisines available on the Asian food delivery service. 
    
Go on a culinary adventure by ordering on Asian food online at airasia Food and enjoy a never ending choice of food. Simply look for ‘Asian food delivery near me’ on the site and pick from the many options there. You are bound  to find one you’d enjoy.`,
      title: `Best Asian Food in ${location}`,
    },
    {
      text: `A healthy lifestyle includes physical health, mental health and what we eat on a daily basis. When it comes to food, eating healthy need not be bland or boring. And the best part is that airasia food helps you stay the course with a variety of meals available with the healthy food delivery service on the site and super app. 

Online healthy food delivery is simple and fuss-free with airasia food. Some of the best healthy food in ${location} that includes vegan and vegetarian options will be delivered to your doorstep daily for you to enjoy. 
                
Search for ‘healthy food near me’ on the web page and scroll through the many delicious options there. You’ll be amazed at the variety and amazing prices on some of the top healthy food in ${location} on offer. This affordable healthy meal delivery service ensures you eat well and save on your food bill too.
                
Dining on healthy food in Malaysia has become increasingly popular in recent years. Consumers are looking for food from ‘healthy restaurants’ that can help them with their fitness goals. But it is not just about having a great body. It is also about enjoying food prepared with nutritious ingredients and tastes great as well.
                
With airasia food healthy meal delivery service providing tasty and nutritious meals for you, your journey to a healthier version of yourself starts with a click of a button. The selection of ready to eat meals to help you with your weight loss programme or for muscle gain will see you achieving a well balanced lifestyle in no time at all.`,
      title: `Best Healthy Food in ${location}`,
    },
    {
      text: `Enjoy some of the best Western food in ${location} without ever having to step out of your house! If the list of Asian dishes available on airasia food site and super app is not extensive already, you will love the array of Western food offered there for your dining pleasure.

Treat yourself to a lovely meal or have a romantic dining experience with your loved one right at home by taking advantage of the Western food home delivery service by airasia food. Restaurants with some of the top Western food in ${location} are now offering their dishes for home delivery. The food is delicious and always at an affordable price point with airasia food!
    
Search for ‘Western food near me’ on the web page and scroll through the many delicious options there. You’ll be amazed at the variety and amazing prices on some of the top Western food in ${location} on offer. Be it a juicy slab of ribeye steak, a grilled chicken chop or even a hearty pork burger, the Western dishes available are endless when you order from airasia food. You can also get desserts like burnt cheesecake and apple pie!
    
For Muslim customers, simply look for ‘Western halal food near me’ on airasia food. The site/app will give you options on Western restaurants that serve halal Western food located close to you.
    
This Western food delivery from airasia food invites you to feast on delectable dishes from restaurants that will serve you only the best. Try it. You won't be disappointed!`,
      title: `Best Western Food in ${location}`,
    },
    {
      text: `EIf you think that vegetarian food is bland and unappetising, guess again. Vegetarian food these days is delicious, varied and just as flavourful as any meat dish. Vegetarian food delivery is also easily available these days. All you need to do is look for the vegetarian food delivery near you on airasia food or the airasia super app and you will be presented with a list of the best vegetarian food online. Whether you’re in the mood for Indian vegetarian food, Chinese vegetarian food or even Western vegetarian food, you’ll be sure to find them there.
                
Indian food has plenty of delicious vegetarian options. If you want healthy Indian food, then vegetarian dishes are your best bet. Indian vegetarian food delivery is easily available in many cities in Malaysia. Just look out for Indian food delivery and chances are, you’ll find plenty of vegetarian options that will suit even the most picky eater. 
                
If Indian vegetarian food is not for you, then look for vegetarian food delivery near you. You’ll find a list of online vegetarian food delivery services offering various other types of vegetarian options ranging from sumptuous salads and pasta dishes to delicious stir-frys and even gourmet burgers. 
                
If you’re craving for it, you’ll find it on airasia food and your vegetarian meal delivery will be sent to you still piping hot.`,
      title: `Best Vegetarian Food in ${location}`,
    },
    {
      text: `You’ve had your meal and now you’re craving for something to satisfy your sweet tooth. All you have to do is check out delivery of desserts near me on airasia food or on the airasia super app and you’ll find an endless array of tantalising sweets that are guaranteed to please. 

If you thought that only savoury meals could be delivered to your doorstep, guess again. Now, with online dessert delivery, you can get any type of sweet treat you want delivered to you - even cakes, ice cream and shaved ice desserts! 

If you can’t make up your mind on what to have, all you have to do is search for the best desserts delivery near me and you’ll be presented with an array of choices. By applying the filter, you’ll be able to locate the merchants who sell desserts only, as well as the ones who are located closest to where you are. 
                
Whether you want a creamy burnt cheesecake, delicious ice creams, decadent chocolate cookies, refreshing shaved ice desserts or even local favourites like crunchy banana fritters and colourful Nyonya kuih, you’ll find it all on airasia food. 
                
Scroll through the many listings and find the best dessert delivery and it will be sent to you any time you have a hankering for something sweet.  With airasia food, searching for ‘dessert delivery near me’ just got a whole lot easier!`,
      title: `Best Dessert in ${location}`,
    },
    {
      text: `It’s a scorching day and you need something refreshing to cool off. Just head over to airasia food or the airasia super app and check out the online drinks delivery menu.

There, you’ll find a wide selection of merchants offering you various types of beverages - both hot and cold - that will surely quench your thirst.  
                
To do your beverage online shopping, all you have to do is turn on the filter and set it to ‘Beverages’. You’ll then see a range of merchants offering you some of the most exciting and unique beverages closest to your location. 
                
Simply place your order and your drink of choice will be delivered to you whenever you want it. Beverage online delivery has never been this easy!
                
If you’re after rich bubble teas to cool off, strong coffee drinks to keep you awake, delicious teh tarik as a pick me up, creamy milkshakes for an after-meal dessert or even if you’re looking for healthy drinks online like a refreshing fruit smoothie after the gym, you’ll find them all on airasia food. 
                
With airasia food, shopping for food and beverage online has never been easier. A simple scroll and a few clicks and whatever you’re craving for will be sent right to your door. To brighten up someone’s day, you can also send any of these beverages to your friends or family members who are not living with you.`,
      title: `Best Beverage in ${location}`,
    },
  ]

  if (countryUrl == "/th/th/") {
    data = [
      {
        text: `หากคุณกำลังต้องการสั่งอาหารเดลิเวอรี่ออนไลน์ ในเขตพื่นที่ ${location} ไม่ต้องกังวล แอร์เอเชียฟู๊ด พร้อมให้คุณสั่งอาหารออนไลน์ได้ง่ายๆ ผ่านแอร์เอเชียซุปเปอร์แอพ ทุกที่ ทุกเวลา นอกจากจะสั่งเพื่อจัดส่งในทันทีแล้ว คุณยังสามารถสั่งอาหารล่วงหน้าเพื่อให้จัดส่งในภายหลังได้ด้วยเช่นกัน. 
  เข้าไปที่แอร์เอเชียฟู๊ดหนึ่งในแพลตฟอร์มสั่งอาหารเดลิเวอรี่ที่ดีที่สุดแล้วเลือก ‘อาหารเดลิเวอรี่ออนไลน์ใกล้ฉัน’ ด้วยบริการอาหารเดลิเวอรี่ของแอร์เอเชีย คุณจะได้พบกับร้านอาหารมากมาย กับอาหารหลากหลายประเภทที่รวมไปถึงอาหารเพื่อสุขภาพออนไลน์ที่พร้อมให้คุณเลือกสรรไม่ว่าจะเป็น อาหารนานาชาติ อาหารตำรับอาเซียน อาหารมังสวิร้ติ อาหารตะวันตก อาหารเพื่อสุขภาพ หรืออาหารคลีน (Clean Food) นอกจากนี้ยังเรายังมีของหวานและเครื่องดื่มไว้คอยบริการคุณด้วยเช่นกัน. 
  ง่ายๆ เพียงคุณเลือกประเภทอาหารที่คุณต้องการ จากนั้นคุณจะได้พบกับรายการร้านค้า ร้านอาหารมากมายที่อยู่ใกล้คุณ จากนั้นเลื่อนดูรายการร้านหรือเลือกอาหารที่คุณชื่นชอบได้เลย. 
  หรือหากคุณต้องการดูรายการร้านอาหารแต่ละประเภทในเขตพื้นที่จังหวัดที่คุณอยู่ คุณเพียงเลือกค้นหาตามประเภทอาหารและเขตจังหวัดที่คุณต้องการ เช่น อาหารมังสวิรัติในกรุงเทพ หรืออาหารเพื่อสุขภาพในกรุงเทพ คุณก็จะได้พบกับร้านอาหารที่แบบที่คุณต้องการอย่างง่ายดาย . 
  นอกจากนี้ เรายังมีโปรโมชั่นอาหารเดลิเวอรี่มากมายสำหรับรายการอาหารที่คุณชื่นชอบและโปรดปราน ดาวน์โหลดแอร์เอเชีย ซุปเปอร์แอพ หนึ่งในแอพสั่งอาหารที่ดีที่สุด แล้วคุณจะได้พบกับโปรโมชั่นสุดพิเศษสำหรับการสั่งอาหาร และส่วนลดจากทางร้านอาหารชั้นนำมากมาย.`,
        title: `สั่งอาหารเดลิเวอรี่ออนไลน์ (Food Delivery) ใน ${location}`,
      },
      {
        text: `อาหารเดลิเวอรี่หรือการสั่งอาหารออนไลน์เดลิเวอรี่ ได้กลายเป็นส่วนสำคัญในชีวิตประจำวันของเราไปแล้ว ทุกวันนี้คุณสามารถสั่งซื้ออาหารได้เกือบทุกประเภทผ่านช่องทางออนไลน์ในราคาถูก สบายกระเป๋า นอกจากนี้ยังมีโปรโมชั่นอาหารเดลิเวอรี่ต่างๆ จากร้านค้าชั้นนำมากมายไว้คอยให้คุณได้เลยใช้บริการได้ตลอดเวลา. 
  หากคุณต้องการสั่งอาหารออนไลน์​ผ่านบริการอาหาร Delivery ง่ายๆ เพียงเข้าไปที่แอร์เอเชียฟู๊ด (airasia Food) แล้วมองหา ‘บริการจัดส่งอาหารเดลิเวอรี่’ หรือ 'อาหารเดลิเวอรี่ใกล้ฉัน' คุณก็จะพบกับร้านอาหารออนไลน์มากมายพร้อมด้วยโปรโมชั่นส่วนลดพิเศษที่พร้อมให้บริการคุณ ไม่ว่าคุณกำลังมองหาอาหารเอเชียรสเลิศหรืออาหารตะวันตกสุดหรู หรือแม้กระทั่งร้านอาหารตามสั่งเดลิเวอรี่ คุณจะพบเมนูเหล่านั้นได้ในแอพสั่งอาหารแอร์เอเชียฟู๊ดอย่างแน่นอน. 
  ค้นหาประเภทอาหารที่คุณชื่นชอบไม่ว่าจะเป็นบริการอาหารมังสวิรัติเดลิเวอรี่ใน ${location} บริการอาหารเพื่อสุขภาพเดลิเวอรี่ใน ${location} หรือบริการอาหารฮาลาลเดลิเวอรี่ใน ${location}. 
  ยิ่งไปกว่านั้นเรายังมีบริการของหวานเดลิเวอรี่ไว้บริการสำหรับผู้ที่ชื่นชอบการสั่งขนมหวานเดลิเวอรี่หรืออาหารว่างออนไลน์ และด้วยบริการที่หลากหลายและครอบคลุมทำให้คุณสามารถสั่งอาหารออนไลน์ใน ${location} หรือจากบริเวณพื้นที่ใกล้เคียงได้ง่ายกว่าที่เคย. 
  นอกจากนี้ หากคุณกำลังมองหาบริการจัดส่งอาหารออนไลน์ที่ดีที่สุด หรือโปรโมชั่นอาหารเดลิเวอรี่ ก็สามารถทำได้ง่ายๆ เพียงโหลดแอร์เอเชียซุปเปอร์แอพ (airasia super app) ซึ่งเป็นแอพสั่งอาหารเดลิเวอรี่ที่ดีที่สุด ที่มีข้อเสนอโปรโมชั่นสั่งอาหารออนไลน์มากมายให้คุณได้เลือกสรรตามความชอบใจ หรือจะเป็นโปรโมชั่นอร่อยสุดคุ้มต่างๆ ที่มีอยู่อย่างต่อเนื่อง ซึ่งจะทำให้คุณสามารถรับ บริการจัดส่งอาหารออนไลน์เดลิเวอรี่ที่ดีที่สุดได้ในราคาที่เหมาะสมที่สุด. 
  ติดตามให้ดี.. เรามีโปรโมชั่นเเละข้อเสนอสุดพิเศษที่คุณไม่ควรพลาดตลอดเวลา ทั้งบนแอร์เอเชียฟู๊ด และแอร์เอเชียซุปเปอร์แอพ.`,
        title: `โปรโมชั่นสั่งอาหารเดลิเวอรี่ใน ${location}`,
      },
      {
        text: `ชาวมุสลิมจะปฏิบัติตามข้อกำหนดด้านอาหารอย่างเคร่งครัด ทำให้พวกเขาใส่ใจกับการเลือกอาหารที่จะรับประทานอย่างเป็นพิเศษ ไม่ว่าจะเป็นส่วนผสม การเตรียมอาหาร และสถานที่ประกอบอาหาร ที่ต้องเป็นไปตามข้อปฏิบัติทางศาสนา. 
  ไม่ต้องกังวลกับการสั่งอาหารเดลิเวอรี่อีกต่อไป เมื่อคุณสามารถสั่งอาหารฮาลาลออนไลน์เพื่อลิ้มรสอาหารมุสลิมแสนอร่อยใน ${location} ได้จากร้านอาหารที่ถูกต้องตามหลักของชาวมุสลิมด้วยบริการจัดส่งอาหารฮาลาลเดลิเวอรี่จากแอร์เอเชียฟู๊ด (airasia food) บริการอาหารมุสลิมเดลิเวอรี่ หรืออาหารฮาลาลออนไลน์เดลิเวอรี่นี้เป็นความมุ่งมั่นของเราในการนำเสนออาหารฮาลาลรสเลิศจากทั่วทุกมุมของ ${location} ให้กับชาวมุสลิมได้อิ่มอร่อยและเพลิดเพลินกับอาหารหลากหลายเมนูที่ผ่านการรับรองฮาลาลอย่างถูกต้อง. 
  เมื่อคุณสั่งอาหารฮาลาลเดลิเวอรี่จากแอร์เอเชียฟู๊ด คุณจะได้ลิ้มรสอาหารฮาลาลชั้นนำใน ${location} พร้อมด้วยประสบการณ์ที่ดีในการรับประทานอาหาร โดยคุณไม่จำเป็นต้องก้าวเท้าออกจากบ้าน และจะดียิ่งขึ้นไปอีกหากคุณได้รับบริการจัดส่งอาหารฮาลาลที่รวดเร็วพร้อมส่วนลดโปรโมชั่นอาหารฮาลาลมากมาย อีกทั้งยังได้รับคะแนนสะสม Big Points สำหรับสมาชิก BIG ทุกครั้งที่สั่งอาหารฮาลาลเมนูโปรดของคุณ. 
  ไม่ว่าจะเป็นอาหารฮาลาลสไตล์จีนที่เป็นที่นิยมอย่างมากในแอร์เอเชียฟู๊ด เรายังมีร้านอาหารจีนฮาลาลและอาหารจีนมุสลิมมากมายที่พร้อมให้บริการ และเสิร์ฟให้ลูกค้าด้วยการปรุงตามสูตรต้นตำรับ หรือหากคุณต้องการอาหารตะวันตกฮาลาล ก็สามารถค้นหาผ่านแอร์เอเชียฟู๊ดได้โดยมองหาอาหารตะวันตกฮาลาลใกล้ฉัน จากนั้นแอปพลิเคชันจะแสดงรายชื่อร้านอาหารฮาลาลสไตล์ตะวันตกที่อยู่ใกล้คุณที่สุดให้คุณได้เลือกสรรอย่างจุใจ. 
  นอกจากนี้ หากคุณอยากทานอาหารเกาหลีอร่อยๆ เราก็ยังมีบริการจัดส่งอาหารเกาหลีฮาลาลเดลิเวอรี่ไว้บริการคุณ เช่น บุลโกกิ หรือบิบิมบับด้วยเช่นกัน หรือหากคุณเป็นอีกคนที่ต้องการดูแลสุขภาพเป็นพิเศษ บริการจัดส่งอาหารฮาลาลเพื่อสุขภาพเดลิเวอรี่จะช่วยตอบโจทย์การดูแลตนเองของคุณได้เป็นอย่างดี.`,
        title: `อาหารฮาลาลที่ดีที่สุดใน ${location}`,
      },
      {
        text: `เอเชียเป็นแหล่งรวมวัฒนธรรมและอาหาร ที่ได้รับการยอมรับว่าเป็นแหล่งรวบรวมอาหารที่ดีที่สุดในโลกแห่งหนึ่ง ตอนนี้คุณไม่จำเป็นต้องเสียเวลาเดินทางไปถึงต่างประเทศ ก็สามารถชิมอาหารที่ดีที่สุดทั่วเอเชียได้ง่ายๆ เพียงแค่คุณสั่งอาหารจาก airasia food คุณก็จะได้ลิ้มรสอาหารเอเชียชั้นนำได้ใน  ${location}. 
  ร้านอาหารเอเชีย ชื่อดังมากมายได้เข้าร่วมเป็นส่วนหนึ่งในร้านอาหารออนไลน์กับ airasia food ซึ่งมีตั้งแต่ร้านระดับ อาหารภัตตาคาร จนถึงร้าน อาหารตามสั่ง เลิศรสที่พร้อมจะเสิร์ฟ อาหารเอเชีย ที่อร่อยที่สุดใน  ${location} ที่พร้อมนำเสนอ เมนูเด็ด ของแต่ละร้านค้า นอกจากนี้คุณยังสามารถลองชิม อาหารข้างทาง ที่มีชื่อเสียงจากตลาดกลางคืนใน  ${location} ได้อีกด้วย. 
  บริการสั่งอาหารเอเชียเดลิเวอรี่จากแอร์เอเชียฟู๊ด (airasia food) ได้คัดสรรร้านอาหารพร้อมเสิร์ฟ อาหารเอเชียต้นตำรับ ซึ่งร้านอาหารเหล่านี้ขึ้นชื่อเรื่อง อาหารเอเชียชั้นนำใน  ${location} คุณจะเพลิดเพลินกับ อาหารรสเลิศ ที่พร้อมเสิร์ฟสำหรับมื้อคำ่สุดพิเศษกับคนที่คุณรักถึงหน้าบ้านคุณ. 
  สั่งอาหารเอเชียเดลิเวอรี่ ยอดนิยมไม่ว่าจะเป็นอาหารจีน เช่น ข้าวผัด ก๋วยเตี๋ยว ของทอดและนึ่ง หรือแม้แต่ติ่มซำ คุณสามารถสั่งเมนูยอดนิยมตลอดกาลเหล่านี้จาก ร้านอาหารจีน ชื่อดังมากมายที่มีจำหน่ายแล้วที่แอร์เอเชียฟู๊ด นอกจากนี้คุณยังสามารถเพลิดเพลินกับอาหารน่ารับประทานจากร้านอาหารเอเชียอื่นๆ ที่เรามีพร้อมให้บริการคุณ ไม่ว่าจะเป็น อาหารญี่ปุ่น อาหารไทย อาหารศรีลังกา อาหารเกาหลี หรือ อาหารเวียดนาม ซึ่งนี่เป็นเพียงบางส่วนของอาหารที่มีชื่อเสียงในบริการสั่งอาหารเอเชียเดลิเวอรี่ เท่านั้น. 
  เปิดประสบการณ์ใหม่ในมื้ออาหาร ด้วยการสั่งอาหารเอเชียออนไลน์ ที่ airasia food และเพลิดเพลินกับอาหารมากมายที่มีให้เลือกชิมลิ้มรสแบบไม่รู้จบ เพียงมองหา 'อาหารเอเชียเดลิเวอรี่ใกล้ฉัน' แล้วเลือกอาหารที่มีอยู่อย่างหลากหลายที่นั่น คุณจะได้พบกับเมนูที่คุณตามหาและชื่นชอบอย่างแน่นอน.`,
        title: `สุดยอดอาหารเอเชียใน ${location}`,
      },
      {
        text: `อาหารที่เราเลือกรับประทานในแต่ละวันนั้น มีส่วนสำคัญต่อชีวิต สุขภาพกายและใจของเรา ในปัจจุบัน การรับประทานอาหารเพื่อสุขภาพ ไม่ใช่เรื่องที่จืดชืดหรือน่าเบื่ออีกต่อไป และด้วยบริการของ airasia food จะช่วยให้ทุกมื้อของคุณเต็มไปด้วยคุณภาพ ด้วยบริการอาหารเพื่อสุขภาพเดลิเวอรี่บนเว็บไซต์และซูเปอร์แอพ. 
  ด้วยบริการแอร์เอเชียฟู๊ด (airasia food) เรามีอาหารเพื่อสุขภาพออนไลน์ที่พร้อมให้คุณสั่ง อาหารเพื่อสุขภาพที่ดีที่สุดใน  ${location} ได้อย่างไม่ยุ่งยาก นอกจากอาหารไทยเพื่อสุขภาพออนไลน์แล้ว บริการอาหารเพื่อสุขภาพออนไลน์เดลิเวอรี่นี้ยังรวมถึง อาหารมังสวิรัติ ที่พร้อมจัดส่งถึงประตูบ้านคุณเพื่อให้คุณลิ้มลองได้ทุกวันตามต้องการ. 
  ค้นหา 'อาหารเพื่อสุขภาพใกล้ฉัน' บนหน้าเว็บไซต์และเลื่อนดูตัวเลือกหลากหลายที่เราได้คัดสรรมาเพื่อคุณ พบกับตัวเลือกที่หลากหลายของ อาหารเพื่อสุขภาพชั้นนำใน  ${location} ในราคาที่น่าประทับใจ ด้วยบริการ อาหารเพื่อสุขภาพราคาประหยัดเดลิเวอรี่ นี้ทำให้คุณได้สัมผัสประสบการณ์ในการรับประทานอาหารชั้นเลิศในราคาที่แสนประหยัด. 
  การรับประทาน อาหารเพื่อสุขภาพในประเทศไทย ได้รับความนิยมมากขึ้นเรื่อยๆ ในช่วงไม่กี่ปีที่ผ่านมานี้ผู้บริโภคต่างมองหาตัวเลือกจาก ‘ร้านอาหารเพื่อสุขภาพ’ ที่มีส่วนเสริมสุขภาพที่ดี และไม่ใช่แค่การมีสุขภาพร่างกายที่ดีเท่านั้น ยังหมายถึงโอกาสที่จะเพลิดเพลินไปกับอาหารที่ได้รับการปรุงแต่งด้วยส่วนผสมที่มีคุณค่าทางโภชนาการและรสชาติที่ดีอีกด้วย.
  พบบริการอาหารเพื่อสุขภาพเดลิเวอรี่ พร้อมด้วยโปรโมชั่นอาหารเพื่อสุขภาพเดลิเวอรี่มากมาย ที่แอร์เอเชียฟู๊ดคุณจะได้รับทั้งความอร่อยและคุณค่าทางโภชนาการไปพร้อมๆ กัน การมีสุขภาพที่ดีจะเป็นเรื่องที่ง่ายสำหรับคุณเพียงสั่งได้ง่ายๆ ผ่านปลายนิ้ว กับตัวเลือกที่หลากหลายของอาหารเพื่อสุขภาพพร้อมรับประทาน ตลอดจนอาหารลดน้ำหนัก ที่พร้อมให้คุณได้อิ่มอร่อยในช่วงควบคุมอาหารด้วยโปรแกรมลดน้ำหนัก หรือเสริมสร้างกล้ามเนื้อ ซึ่งจะทำให้เป้าหมายของการมีวิถีชีวิตที่สมดุลและสุขภาพดีเป็นจริงได้ไม่ยาก.`,
        title: `อาหารเพื่อสุขภาพที่ดีที่สุดใน ${location}`,
      },
      {
        text: `ดื่มด่ำกับ อาหารตะวันตกเลิศรสใน ${location} ได้โดยไม่ต้องก้าวเท้าออกจากบ้าน ด้วยความหลากหลายของเมนู อาหารตะวันตก (Western food) ที่มีให้บริการอยู่ในแอร์เอเชียฟู๊ด (airasia food) และแอร์เอเชียซุปเปอร์แอพ (airasia super app) จะทำให้คุณเพลิดเพลินไปการเลือกสั่งอาหารตะวันตกออนไลน์สำหรับมื้อสำคัญของคุณ. 
  เติมความสุขให้กับตัวเองด้วยอาหารอร่อย หรือสัมผัสประสบการณ์มื้ออาหารแสนโรแมนติกกับคนที่คุณรักที่บ้าน โดยให้ airasia food ช่วยดูแลคุณด้วย อาหารตะวันตกเดลิเวอรี่ ที่พร้อมเสริ์ฟให้คุณถึงหน้าบ้าน นอกจากนี้ airasia food ยังมีอาหารตะวันตกร้านดังใน ${location}  มากมายให้คุณได้เลือกสรรในราคาสุดคุ้ม. 
  หากคุณกำลังมองหาอาหารตะวันตกเดลิเวอรี่เสริ์ฟถึงบ้าน เราอยากให้คุณลองค้นหาโดยพิมพ์คำว่า ‘อาหารตะวันตกเดลิเวอรี่ใกล้ฉัน’ ‘อาหารตะวันตกที่ดีที่สุดใกล้ฉัน’ หรือ ‘อาหารตะวันตกใกล้ฉัน’ ในหน้าเว็ป จากนั้นคุณจะได้พบกับรายชื่อร้าน อาหารตะวันตกมากมายใน ${location} ในราคาสุดคุ้ม ที่พร้อมส่งถึงมือคุณได้อย่างรวดเร็ว ไม่ว่าจะเป็นเมนู ริบอาย สเต็ก ไก่ย่าง ฟิชแอนด์ชิพ หรือ เบอร์เกอร์หมู แม้แต่เมนูของหวานอย่างชีสเค้ก หรือ พายแอปเปิ้ล และเมนูอื่นๆ อีกมากมายก็มีให้คุณเลือกสรรอย่างจุใจใน airasia food.
  นอกจากนี้ ยังมีอาหารฮาลาลสำหรับชาวมุสลิม เพียงกดค้นหา ’อาหารฮาลาลสไตล์ตะวันตกใกล้ฉัน’ ที่ airasia food คุณก็จะได้พบกับร้าน อาหารตะวันตกฮาลาล มากมายที่อยู่ในบริเวณใกล้เคียงคุณ.
  การ สั่งอาหารตะวันตกเดลิเวอรี่ ผ่าน airasia food จะเปิดประสบการณ์ใหม่ให้คุณค้นพบความสนุกสนานในการสั่งอาหารจากร้านอาหาร ที่จะเสิร์ฟอาหารที่ดีที่สุดให้คุณ ลองได้แล้ววันนี้ คุณจะไม่ผิดหวังอย่างแน่นอน.`,
        title: `อาหารตะวันตกที่ดีที่สุดใน ${location}`,
      },
      {
        text: `อาหารมังสวิรัติเดลิเวอรี่, อาหารมังสวิรัติ Delivery, อาหารมังสวิรัติเดลิเวอรี่ใกล้ฉัน, อาหารมังสวิรัติเดลิเวอรี่ดีที่สุด, อาหารอินเดียเดลิเวอรี่, อาหารอินเดีย Delivery, อาหารอินเดียเพื่อสุขภาพ, อาหารมังสวิรัติสไตล์อินเดีย, อาหารมังสวิรัติสไตล์อินเดียเดลิเวอรี่, อาหารอินเดียมังสวิรัติ, อาหารตะวันตกมังสวิรัติ, อาหารจีนมังสวิรัติจีน, อาหารมังสวิรัติสไตล์จีน, อาหารมังสวิรัติสไตล์ตะวันตก. 
  หากคุณคิดว่าอาหารมังสวิรัติเป็นอะไรที่มีรสชาติจืดชืดและไม่ชวนให้รับประทาน เราอยากให้คุณได้ลองเปิดใจใหม่อีกสักครั้ง ทุกวันนี้อาหารมังสวิรัตินั้นมีความหลากหลาย มีเมนูให้เลือกสรรมากมายพร้อมด้วยรสชาติที่อร่อยถูกปากไม่แพ้กับอาหารที่ใช้เนื้อสัตว์ในการปรุงเลย. 
  การซื้อหาอาหารมังสวิรัติก็ไม่ใช่เรื่องยากอีกต่อไปเพียงสั่งอาหารมังสวิรัติเดลิเวอรี่กับเรา สิ่งที่คุณต้องทำก็แค่เพียงมองหาอาหารมังสวิรัติ Delivery หรือบริการจัดส่งอาหารมังสวิรัติเดลิเวอรี่ใกล้ฉัน หนึ่งในบริการของแอร์เอเชียฟู๊ด (airasia food) บนแอร์เอเชียซุปเปอร์แอพ (airasia Super App) แล้วคุณจะพบกับตัวเลือกที่หลากหลายของ อาหารมังสวิรัติออนไลน์ที่ดีที่สุด ไม่ว่าคุณจะชอบอาหารอินเดียมังสวิรัติ (อาหารมังสวิรัติสไตล์อินเดีย) อาหารจีนมังสวิรัติจีน (อาหารมังสวิรัติสไตล์จีน) หรือแม้แต่อาหารตะวันตกมังสวิรัติ (อาหารมังสวิรัติสไตล์ตะวันตก) ทั้งหมดนี้ คุณสามารถค้นหาได้ที่แอร์เอเชียฟู๊ด. 
  อาหารสไตล์อินเดียนับเป็นอีกหนึ่งตัวเลือกสำหรับชาวมังสวิรัติและผู้รักสุขภาพ หากคุณคือผู้ที่ชื่นชอบการรับประทานอาหารอินเดียเพื่อสุขภาพ อาหารมังสวิรัติสไตล์อินเดียนับเป็นทางเลือกที่ดีที่สุดสำหรับคุณ อาหารมังสวิรัติสไตล์อินเดียเดลิเวอรี่ นั้นเป็นที่แพร่หลายและมีพร้อมให้บริการจัดส่งอย่างมากมาย เพียงมองหาอาหารอินเดียเดลิเวอรี่ หรืออาหารอินเดีย Delivery เรามั่นใจได้ว่าคุณจะต้องพบกับเมนูหลากหลายที่ถูกใจชาวมังสวิรัติตัวยงเช่นคุณอย่างแน่นอน. 
  หากอาหารมังสวิรัติสไตล์อินเดียไม่ใช่แนวที่คุณชื่นชอบ เราขอแนะนำให้คุณบลองค้นหาอาหารมังสวิรัติเดลิเวอรี่ดีที่สุด หรืออาหารมังสวิรัติเดลิเวอรี่ใกล้ฉัน แล้วคุณจะพบกับรายการ อาหารมังสวิรัติออนไลน์เดลิเวอรี่ ที่มีตัวเลือกอาหารมังสวิรัติในประเภทอื่นๆ อีกมากมาย ไม่ว่าจะเป็นสลัดและพาสต้าไปจนถึงเมนูผัดที่แสนอร่อยหรือแม้แต่เบอร์เกอร์รสเลิศด้วยเช่นกัน. 
  หากคุณต้องการลิ้มลอง เพียงเข้าไปที่แอร์เอเชียฟู๊ด (airasia food) แล้วสั่ง อาหารมังสวิรัติเดลิเวอรี่ เพียงเท่านี้เมนูโปรดของคุณก็จะถูกส่งถึงมือคุณแบบสดใหม่ ร้อนๆ เหมือนเพิ่งออกจากเตาอย่างแน่นอน!`,
        title: `อาหารมังสวิรัติที่ดีที่สุดในย่าน ${location}`,
      },
      {
        text: `หลังจากที่อิ่มอร่อยกับคาวมื้อหลักเรียบร้อยแล้ว สิ่งที่คุณไม่ควรพลาดก็คือหาของหวานที่จะมาตบท้ายความอร่อยในมื้อโปรดของคุณ สิ่งที่คุณต้องทำก็เพียงแค่ค้นหาของหวานเดลิเวอรี่ดีที่สุดใกล้ฉัน หรือบริการจัดส่งของหวานเดลิเวอรี่ที่แอร์เอเชียฟู๊ด (airasia food) บนแอร์เอเชียซุปเปอร์แอพ (airasia super app) รับประกันได้ว่าคุณจะพอใจกับรายการของหวานเดลิเวอรี่ที่มีพร้อมให้บริการคุณอย่างมากมายภายใต้รายการของหวาน Delivery ที่มีให้บริการบนแอปพลิเคชั่นของเรา. 
  ไม่เพียงแค่อาหารคาวหรืออาหารมื้อหลักเท่านั้นที่พร้อมให้บริการจัดส่งถึงมือคุณ ด้วยบริการของหวาน Deliveryของเรา คุณสามารถเลือกสั่งเพียงของหวาน ขนม หรือเบเกอรี่ได้ด้วยเช่นกัน เลือกเมนูโปรดที่คุณต้องการ ไม่ว่าจะเป็น เค้ก ไอศกรีม หรือแม้กระทั่งน้ำแข็งไส แล้วรอรับความอร่อยผ่านบริการของหวานเดลิเวอรี่แบบชิวๆ ที่บ้านคุณได้เลย. 
  หากคุณยังคิดไม่ออกว่าจะทานอะไรดี เพียงคุณกดค้นหาของหวานเดลิเวอรี่ใกล้ฉัน หรือของหวานร้านดังเดลิเวอรี่ใกล้ฉัน คุณก็จะพบกับตัวเลือกร้านค้าสำหรับของอร่อยมากมาย และยิ่งง่ายต่อการค้นหายิ่งขึ้นหากคุณใช้ตัวกรองเมื่อทำการค้นหา จากนั้นคุณก็จะพบกับร้านของหวาน ขนมหวาน หรือของว่างจานโปรดที่อยู่ใกล้คุณที่สุดอีกด้วย. 
  ด้วยบริการสั่งของหวานออนไลน์ไม่ว่าจะเป็นของหวานประเภทไหน ชีสเค้ก ไอศกรีมแสนอร่อย คุกกี้ช็อกโกแลต น้ำแข็งใส หรือขนมจานโปรดประจำท้องถิ่นอย่างกล้วยชุบแป้งทอดหรือขนมหวานแบบดั้งเดิมหลากสีสัน คุณจะพบทุกอย่างได้ในของหวานออนไลน์เดลิเวอรี่บนแอร์เอเชียฟู๊ด. 
  เลื่อนดูรายการอาหารแล้วกดค้นหาบริการจัดส่งของหวานเดลิเวอรี่ทุกครั้งเมื่อคุณต้องการความหวาน เราพร้อมที่จะจัดส่งความอร่อยถึงมือคุณ ด้วยบริการจากแอร์เอเชียฟู๊ด อย่าลืมกดค้นหา`,
        title: `ของหวานที่ดีที่สุดใน ${location}`,
      },
      {
        text: `ในวันที่แสนร้อนอบอ้าวและต้องการเครื่องดื่มเย็นๆ เพื่อดับกระหาย เพียงแค่คุณเข้าไปที่แอร์เอเชียฟู๊ด (airasia food) หรือ airasia super app แล้วค้นหาเครื่องดื่ม Delivery คุณก็จะได้พบกับเมนู เครื่องดื่มเดลิเวอรี่มากมาย ที่พร้อมส่งตรงถึงมือคุณได้ในทันที. 
  ที่แอร์เอเชียฟู๊ด (airasia food) ในหมวดหมู่เครื่องดื่มออนไลน์เดลิเวอรี่ คุณจะได้พบกับร้านค้าเครื่องดื่มออนไลน์ หรือเครื่องดื่มเพื่อสุขภาพออนไลน์ที่พร้อมนำเสนอเมนูเครื่องดื่มยอดนิยมมากมายทั้งแบบร้อนและเย็นที่จะช่วยเติมความสดชื่นดับกระหายให้กับคุณ. 
  หากต้องการสั่งเครื่องดื่มออนไลน์เดลิเวอรี่ คุณเพียงแค่เลือกฟิลเตอร์ ‘เครื่องดื่ม’ คุณก็จะพบกับเมนูเครื่องดื่มออนไลน์และรายการร้านค้าหลากหลายที่อยู่ใกล้คุณและพร้อมส่งเสิร์ฟถึงมือได้ในทันที.
  สั่งเครื่องดื่มออนไลน์ ผ่าน แอร์เอเชียฟู๊ด (airasia food) นั้นทำได้ง่ายๆ ด้วยการเลือกสั่งเครื่องดื่มที่คุณต้องการ จากนั้นเครื่องดื่มเมนูโปรดของคุณก็ะถูกจัดส่งตรงถึงมือคุณได้ทุกเมื่อที่คุณต้องการ. 
  หากคุณต้องการดื่มชานมไข่มุกแสนอร่อย กาแฟเข้มๆ เพื่อคลายง่วงหรือลดความอ่อนล้า ชาหอมๆ หรือมิลค์เชคสุดเข้มข้นทดแทนของหวานหลังมื้ออาหาร สมูธตี้ผลไม้เพื่อสุขภาพ หรือเมนูเครื่องดื่มอื่นๆ อีกมากมาย คุณสามารถค้นหาได้ใน airasia food. 
  ที่ airasia food การสั่งเครื่องดื่มออนไลน์เป็นเรื่องง่าย เพียงแค่คุณคลิก และเลือกเมนูที่คุณต้องการ เครื่องดื่มเมนูโปรดจะถูกส่งตรงถึงหน้าบ้านคุณ อีกทั้งยังสามารถสั่งเครื่องดื่มแสนอร่อยส่งไปให้เพื่อน สมาชิกในครอบครัว หรือคนที่คุณรักได้ด้วยเช่นกัน.`,
        title: `เครื่องดื่มที่ดีที่สุดใน ${location}`,
      },
    ]
  }

  return data
}

export function filterCarouselDatabyCategory(carouselData, categoryName) {
  let dataFiltered = carouselData.filter(
    fil => fil.category === categoryName
  )[0]
    ? carouselData
        .filter(fil => fil.category === categoryName)[0]
        .stores.slice(0, 3)
    : []

  return dataFiltered
}

export function filterCarouselDatabyTag(storeTagsData, tagName) {
  let dataFiltered = storeTagsData.filter(fil => fil.tags.includes(tagName))
    ? storeTagsData.filter(fil => fil.tags.includes(tagName)).slice(0, 3)
    : []

  return dataFiltered
}

export function getStoresbyCategory(data) {
  let UTM = `?utm_medium=display&utm_source=google&utm_campaign=food_my_none|foodseofaq|12082021|my-en|none|ecomm&utm_content=`
  let storeData = data.map(
    d =>
      `<a style="text-decoration: none;color: red;" href=${
        d.store_url
          ? d.store_url + UTM
          : `https://www.airasia.com/food/my/restaurant/${d.name
              .split(" ")
              .join("-")
              .toLowerCase()
              .replace("’", "")}${UTM}`
      }> ${d.name}</a> `
  )

  return storeData
}

export function getStoresbyTag(data) {
  let UTM = `?utm_medium=display&utm_source=google&utm_campaign=food_my_none|foodseofaq|12082021|my-en|none|ecomm&utm_content=`
  let storeData = data.map(
    d =>
      `<a style="text-decoration: none;color: red;" href=${
        d.store.store_url
          ? d.store.store_url + UTM
          : `https://www.airasia.com/food/my/restaurant/${d.store.name
              .split(" ")
              .join("-")
              .toLowerCase()
              .replace("’", "")}${UTM}`
      }> ${d.store.name}</a> `
  )

  return storeData
}

export function generateFAQs(location, carouselData, countryUrl) {
  const faqs = []

  //get all store which has store tags
  let storeTagsData = []
  carouselData.forEach(el => {
    el.stores.forEach(store => {
      if (store.store_tags) {
        if (store.store_tags.length) {
          let data = {
            store: store,
            tags: store.store_tags.map(e => e.name).join(","),
          }
          storeTagsData.push(data)
        }
      }
    })
  })

  //filter carouselData based on category
  let vegetarianData = filterCarouselDatabyCategory(carouselData, "Vegetarian")
  if (vegetarianData.length) {
    let vegetarianStores = getStoresbyCategory(vegetarianData)
    if (countryUrl === "/th/th/") {
      faqs.push({
        question: `สถานที่แนะนำสำหรับการสั่ง อาหารมังสวิรัติ ใน ${location} มีที่ไหนบ้าง?`,
        answer: `สถานที่ใกล้เคียงประกอบไปด้วย: ${vegetarianStores
          .join(", ")
          .replace(/, ([^,]*)$/, " และ $1")}`,
      })
    } else {
      faqs.push({
        question: `What places are recommended for ordering vegetarian food in ${location}?`,
        answer: `Nearby places include: ${vegetarianStores
          .join(", ")
          .replace(/, ([^,]*)$/, " and $1")}`,
      })
    }
  }

  let westernData = filterCarouselDatabyCategory(carouselData, "Western")
  if (westernData.length) {
    let westernStores = getStoresbyCategory(westernData)
    if (countryUrl === "/th/th/") {
      faqs.push({
        question: `อาหารตะวันตก ที่ดีที่สุดใน ${location} มีร้านไหนบ้าง?`,
        answer: `ตัวเลือกยอดนิยม ได้แก่: ${westernStores
          .join(", ")
          .replace(/, ([^,]*)$/, " และ $1")}`,
      })
    } else {
      faqs.push({
        question: `From which restaurant can I get the best western food delivery in ${location}?`,
        answer: `Popular choices are: ${westernStores
          .join(", ")
          .replace(/, ([^,]*)$/, " and $1")}`,
      })
    }
  }

  let halalData = filterCarouselDatabyCategory(carouselData, "Halal")
  if (halalData.length) {
    let halalStores = getStoresbyCategory(halalData)
    if (countryUrl === "/th/th/") {
      faqs.push({
        question: `สามารถใช้บริการจัดส่งอาหารฮาลาลใน ${location} ได้จากที่ไหน?`,
        answer: `${halalStores
          .join(", ")
          .replace(
            /, ([^,]*)$/,
            " และ $1"
          )} ให้บริการ อาหารฮาลาล จานเด็ดบน airasia Food! สั่งเลย!`,
      })
    } else {
      faqs.push({
        question: `Where can I get halal food delivery in ${location}?`,
        answer: `${halalStores
          .join(", ")
          .replace(
            /, ([^,]*)$/,
            " and $1"
          )} have some great halal dishes on airasia Food! Order now!`,
      })
    }
  }

  //filter storeTagsData based on tags
  let veganData = filterCarouselDatabyTag(storeTagsData, "Vegan")
  if (veganData.length) {
    let veganStores = getStoresbyTag(veganData)
    if (countryUrl === "/th/th/") {
      faqs.push({
        question: `สามารถหาบริการสั่ง อาหารวีแกน เดลิเวอรี่ใน ${location} ได้อย่างไร?`,
        answer: `ลองดู ${veganStores
          .join(", ")
          .replace(/, ([^,]*)$/, " และ $1")} ได้เลยที่ airasia Food!`,
      })
    } else {
      faqs.push({
        question: `How do I find vegan food delivery in ${location}?`,
        answer: `Check out ${veganStores
          .join(", ")
          .replace(/, ([^,]*)$/, " and $1")} on airasia Food now!`,
      })
    }
  }

  let burgerData = filterCarouselDatabyTag(storeTagsData, "Burger")
  if (burgerData.length) {
    let burgerStores = getStoresbyTag(burgerData)
    if (countryUrl === "/th/th/") {
      faqs.push({
        question: `ร้านแนะนำสำหรับการสั่ง เบอร์เกอร์ ออนไลน์ใน ${location} มีร้านใดบ้าง?`,
        answer: `${burgerStores
          .join(", ")
          .replace(
            /, ([^,]*)$/,
            " และ $1"
          )} เป็นร้าน เบอร์เกอร์ ยอดนิยมใน ${location} สำหรับผู้ใช้ airasia Food ลองสั่งเลย!`,
      })
    } else {
      faqs.push({
        question: `Which restaurants are recommended to deliver burger in ${location}?`,
        answer: `${burgerStores
          .join(", ")
          .replace(
            /, ([^,]*)$/,
            " and $1"
          )} are popular for burger in ${location} among our airasia Food users. Try them now!`,
      })
    }
  }

  let bubbleTeaData = filterCarouselDatabyTag(storeTagsData, "Bubble Tea")
  if (bubbleTeaData.length) {
    let bubbleTeaStores = getStoresbyTag(bubbleTeaData)
    if (countryUrl === "/th/th/") {
      faqs.push({
        question: `สามารถสั่ง ชานมไข่มุก ใน ${location} ได้จากที่ไหน?`,
        answer: `สั่งอาหารจาก ${bubbleTeaStores
          .join(", ")
          .replace(/, ([^,]*)$/, " และ $1")} บน airasia Food`,
      })
    } else {
      faqs.push({
        question: `Where can I order bubble tea delivery in ${location}?`,
        answer: `Order from ${bubbleTeaStores
          .join(", ")
          .replace(/, ([^,]*)$/, " and $1")} on airasia Food.`,
      })
    }
  }

  let iceCreamData = filterCarouselDatabyTag(storeTagsData, "Icecream")
  if (iceCreamData.length) {
    let iceCreamStores = getStoresbyTag(iceCreamData.slice(0, 2))
    if (countryUrl === "/th/th/") {
      faqs.push({
        question: `ที่ไหนบ้างที่มีบริการจัดส่ง ไอศกรีม กับ airasia Food ใน ${location}?`,
        answer: `ลองดู ${iceCreamStores
          .join(", ")
          .replace(/, ([^,]*)$/, " และ $1")} ได้ที่ airasia Food!`,
      })
    } else {
      faqs.push({
        question: `Which place delivers creamy ice cream in ${location} with airasia Food?`,
        answer: `Check out ${iceCreamStores
          .join(", ")
          .replace(/, ([^,]*)$/, " and $1")} on airasia Food!`,
      })
    }
  }

  let pizzaData = filterCarouselDatabyTag(storeTagsData, "Pizza")
  if (pizzaData.length) {
    let pizzaStores = getStoresbyTag(pizzaData.slice(0, 2))
    if (countryUrl === "/th/th/") {
      faqs.push({
        question: `ร้านแนะนำสำหรับการสั่ง พิซซ่า ชีสซี่ใน ${location} มีร้านใดบ้าง?`,
        answer: `${pizzaStores
          .join(", ")
          .replace(
            /, ([^,]*)$/,
            " และ $1"
          )} มีบริการ พิซซ่าเดลิเวอรี่ ที่ได้รับความนิยมใน ${location}`,
      })
    } else {
      faqs.push({
        question: `Which restaurants are recommended to deliver cheesy pizza in ${location}?`,
        answer: `${pizzaStores
          .join(", ")
          .replace(
            /, ([^,]*)$/,
            " and $1"
          )} are sought-after for pizza delivery in ${location}.`,
      })
    }
  }

  let nasiLemakData = filterCarouselDatabyTag(storeTagsData, "Nasi Lemak")
  if (nasiLemakData.length) {
    let nasiLemakStores = getStoresbyTag(nasiLemakData)
    if (countryUrl === "/th/th/") {
      faqs.push({
        question: `หาซื้อ นาซิลามัค รสเด็ดใน ${location} ได้จากที่ไหน?`,
        answer: `ลูกค้าของเราใน ${location} มักจะสั่ง นาสิลามัค จาก ${location} from ${nasiLemakStores
          .join(", ")
          .replace(/, ([^,]*)$/, " และ $1")} `,
      })
    } else {
      faqs.push({
        question: `Where can I buy tasty nasi lemak in ${location}?`,
        answer: `Our customers frequently order nasi lemak delivery in ${location} from ${nasiLemakStores
          .join(", ")
          .replace(/, ([^,]*)$/, " and $1")}`,
      })
    }
  }

  let hotPotData = filterCarouselDatabyTag(storeTagsData, "Hot Pot")
  if (hotPotData.length) {
    let hotPotStores = getStoresbyTag(hotPotData.slice(0, 2))
    if (countryUrl === "/th/th/") {
      faqs.push({
        question: `มีบริการจัดส่ง หม้อไฟ ใน ${location} หรือไม่?`,
        answer: `อยากกินอะไร airasia Food พร้อมจัดให้! สั่งได้เลยจาก ${hotPotStores
          .join(", ")
          .replace(/, ([^,]*)$/, " และ $1")}`,
      })
    } else {
      faqs.push({
        question: `Is hot pot deilvery available in ${location}?`,
        answer: `You crave it, airasia Food has it! Order from ${hotPotStores
          .join(", ")
          .replace(/, ([^,]*)$/, " and $1")}`,
      })
    }
  }

  let ketoData = filterCarouselDatabyTag(storeTagsData, "Keto")
  if (ketoData.length) {
    let ketoStores = getStoresbyTag(ketoData.slice(0, 2))
    if (countryUrl === "/th/th/") {
      faqs.push({
        question: `มีร้านอาหารที่ให้บริการจัดส่ง อาหารคีโตใน ${location} หรือไม่?`,
        answer: `airasia Food มีทุกอย่างพร้อมให้คุณลิ้มลอง! สั่ง ${ketoStores
          .join(", ")
          .replace(/, ([^,]*)$/, " และ $1")}`,
      })
    } else {
      faqs.push({
        question: `Do any restaurants offer keto food delivery in ${location}?`,
        answer: `airasia Food has it all! Try out ${ketoStores
          .join(", ")
          .replace(/, ([^,]*)$/, " and $1")}`,
      })
    }
  }

  let sushiData = filterCarouselDatabyTag(storeTagsData, "Sushi")
  if (sushiData.length) {
    let sushiStores = getStoresbyTag(sushiData)
    if (countryUrl === "/th/th/") {
      faqs.push({
        question: `จะรู้ได้อย่างไรว่าร้านอาหารไหนที่ให้บริการจัดส่ง ซูชิ ใน ${location}?`,
        answer: `${sushiStores
          .join(", ")
          .replace(
            /, ([^,]*)$/,
            " และ $1"
          )} เป็นร้านซูชิยอดนิยมสำหรับผู้ใช้งานของเรา สั่งได้เลยบน airasia Food เราจะจัดส่งให้คุณถึงที่!`,
      })
    } else {
      faqs.push({
        question: `How do I know which restaurants deliver sushi in ${location}?`,
        answer: `${sushiStores
          .join(", ")
          .replace(
            /, ([^,]*)$/,
            " and $1"
          )} are some popular restaurants for sushi among our users. Order now on airasia Food and we will deliver to you right away!`,
      })
    }
  }

  return faqs
}
